import type { ReactNode } from "react";

interface Props {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  padded?: boolean;
  className?: string;
}

export function Card({
  title,
  action,
  children,
  padded = true,
  className = "",
}: Props) {
  return (
    <section className={`bbc-card ${className}`.trim()}>
      {(title || action) && (
        <header className="bbc-card-head">
          <h3>{title}</h3>
          {action}
        </header>
      )}
      <div className={padded ? "bbc-card-body" : "bbc-card-body bbc-card-body-flush"}>
        {children}
      </div>
    </section>
  );
}
